import {Component, OnInit, ViewChild} from '@angular/core';
import {OrderService} from "../../../../services/order.service";
import {DatePipe} from "@angular/common";
import {environment} from "../../../../environments/environment";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import {ShopService} from "../../../../services/shop.service";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import { Shop } from '../../../../models/shop.model';
import { UserService } from '../../../../services/user.service';
import { User } from '../../../../models/user.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-users-with-sold-products-details',
  templateUrl: './users-with-sold-products-details.component.html',
  styleUrls: ['./users-with-sold-products-details.component.scss']
})
export class UsersWithSoldProductsDetailsComponent implements OnInit {

  @ViewChild('closebutton') closebutton;
  
    orderItems: any[] = [];
    sorted = 1;
    url_photo: String;
    page: number = 1;
    count: number = 0;
    tableSize: number = 10;
    tableSizes: any = [10, 15, 30, 50];
    search: any;
    seller = false;
    pageNumber: number = 1;
    pageSize: number = 25;
    totalItems :any;
    currentOrderItem : any;
      
    beginDate: any = null;
    endDate: any = null;
    searchText: any = "";
  
    constructor(private orderService:OrderService,     private fb: FormBuilder,
                private datePipe: DatePipe, private shopService:ShopService,
                private userService: UserService, private activatedRoute: ActivatedRoute) { }
                
    ngOnInit(): void {
      this.url_photo = environment.url_photo;
      this.loadOrderItemSeller();
    }
    
    isFilterByProduct: boolean = false;
    isFilterByService: boolean = false;
    isFilterByProductAndService: boolean = true;
    loadOrderItemSeller() {
      this.searchText = this.search !== undefined ? this.search : '';
      this.activatedRoute.params.subscribe(param => {
        this.orderService.findOrdersByUserId(param.id, this.pageNumber-1, this.pageSize).subscribe((rs:any) => {
          this.orderItems = rs.content;
          this.totalItems = rs.totalElements;
          // console.log("Liste des commandesss");
          // console.log(this.orderItems);
          
        });
      });
      
    }
  
  
    sortTransactionsByDate(transactions :any[]) :any[]{
      return transactions.sort((a, b) => {
        const dateA = new Date(a.date).getTime();
        const dateB = new Date(b.date).getTime();
        return dateB - dateA; // Trie du plus récent au plus ancien
      });
    }
    
    searchFilter_v1($event: KeyboardEvent) {
      this.searchText = this.search !== undefined ? this.search : '';
      this.loadOrderItemSeller();
    }
    
    trier(columnName: keyof any) {
      this.sorted = -this.sorted;
      this.orderItems.sort((a, b) => a[columnName] > b[columnName] ? this.sorted : -this.sorted);
    }
    
  
    resetFilter() {
      this.searchText = '';
      this.loadOrderItemSeller();
    }
  
    raiseTableSize(event: any) {
      this.pageSize = event.target.value;
      this.loadOrderItemSeller();
    }
  
    exportexcel(fileName): void {
      /* table id is passed over here */
      let element = document.getElementById('excel-table');
      const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, fileName);
  
    }
    
}
